function replaceAll(text: string, from: string, to: string) {
    if (!text) {
        return "";
    }

    return text.replace(new RegExp(from, "g"), to);
}

const ARABIC_WORDS = ["ﷺ", "ؐ", "ؓ", "؏", "", "ؑ"];

export function fixArabicFont(contents: string) {
    for (let i = 0; i < ARABIC_WORDS.length; i += 1) {
        const w = ARABIC_WORDS[i];
        if (!w) {
            continue;
        }

        contents = replaceAll(
            contents,
            w,
            `<span lang="ar" text="${w}">${w}</span>`
        );
    }

    return contents;
}

export function fixArabicText(contents: string) {
    return {
        __html: fixArabicFont(contents),
    };
}
